import type { Invoice } from '../../types';
import type { CreditCardBrandInput } from '../CreditCard/creditcardTypes';

import type { BrandSurcharge } from './surchargeTypes';

const getBrand = (surchargeType: string): CreditCardBrandInput => {
  switch (surchargeType) {
    case 'AmexSurcharge':
      return 'AMEX';
    default:
      return 'UNKNOWN';
  }
};

const getSurcharges = (orderSummary: any): BrandSurcharge[] => {
  const orderTotal = orderSummary.total.value;
  if (orderTotal) {
    return orderSummary.surcharges.map((surcharge: any) => ({
      brand: getBrand(surcharge.surchargeType),
      surchargePercentage: getSurchargePercentage(
        orderTotal,
        surcharge.amount?.value,
      ),
    }));
  }
  return [];
};

const getInvoiceSurcharges = ({
  surcharge,
  invoice,
}: {
  surcharge: {
    surchargeAmount: number;
    surchargeApplicable: boolean;
  };
  invoice: Invoice[];
}): BrandSurcharge[] => {
  const { surchargeAmount, surchargeApplicable } = surcharge;
  const amountPayable = invoice.reduce((a, b) => a + b.amount, 0);

  if (invoice.length === 0) {
    return [];
  }

  if (surchargeApplicable) {
    return [
      {
        brand: 'AMEX',
        surchargePercentage: getSurchargePercentage(
          amountPayable,
          surchargeAmount,
        ),
      },
    ];
  }
  return [];
};

const getSurchargePercentage = (
  amountPayable: number,
  surchargeAmount?: number,
): number => {
  if (amountPayable === 0) return 0;

  return Math.round((10000 * (surchargeAmount ?? 0)) / amountPayable) / 100;
};

const getSurchargeByBrand = (
  allSurcharges: BrandSurcharge[],
  brand: CreditCardBrandInput,
) => {
  const surchargeForBrand = allSurcharges.find(
    (brandSurcharge: BrandSurcharge) => brandSurcharge.brand === brand,
  );

  return surchargeForBrand?.surchargePercentage ?? 0;
};

export {
  getSurcharges,
  getInvoiceSurcharges,
  getSurchargePercentage,
  getSurchargeByBrand,
};
